import React from 'react'

const projects = [
  {
    name: 'Instagram Clone – Real-Time Social Platform',
    description: `Developed a full-stack social media platform supporting real-time communication and media sharing.

Implemented JWT-based authentication with protected routes and middleware verification.

Built live chat and activity updates using Socket.io WebSockets.

Handled image uploads and storage using Cloudinary with optimized delivery.

Designed MongoDB schemas for users, posts, stories, and conversations with efficient querying.`,
    techStack: 'React.js, Node.js, Express.js, MongoDB, Socket.io, Cloudinary, JWT, Tailwind CSS',
  },
  {
    name: 'E-Commerce Platform with Admin Dashboard',
    description: `Engineered a complete e-commerce system with separate admin and user workflows.

Created product management APIs with create, update, delete, and inventory handling.

Implemented secure login, authorization, and order tracking functionality.

Structured backend controllers and services for maintainable architecture.

Optimized frontend performance and responsiveness using Tailwind CSS.`,
    techStack: 'React.js, Node.js, Express.js, MongoDB, REST APIs, JWT Authentication, Tailwind CSS',
  },
  {
    name: 'PDF Data Extraction and OCR Automation',
    description: `Built a Python-based automation tool to extract structured data from PDF and scanned documents.

Used Tesseract OCR for text recognition and Pandas for data processing.

Parsed unstructured documents into tabular datasets and exported Excel reports.

Designed the system to reduce manual data entry and improve processing speed.`,
    techStack: 'Python, Pandas, Tesseract OCR, OpenCV, PDF Processing',
  },
]


const Projects = () => {
  return (
    <section id="projects" className="bg-accent py-12 sm:py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-10 md:mb-12">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-4xl font-bold mb-4 text-textPrimary">
            Featured Projects
          </h2>
          <div className="w-16 sm:w-20 h-1 bg-primary mx-auto mb-4 sm:mb-6"></div>
          <p className="font-body text-base sm:text-lg text-textSecondary max-w-2xl mx-auto px-4">
            Selected work demonstrating backend architecture, real-time communication, and automation development.
          </p>
        </div>
        
        {/* Projects Grid - Mobile First Responsive */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {projects.map((project, idx) => (
            <div key={idx} className="bg-backgroundDark rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group">
              <div className="p-4 sm:p-6 h-full flex flex-col">
                <div className="flex-grow">
                  <h3 className="font-heading text-lg sm:text-xl font-bold mb-3 sm:mb-4 text-textPrimary group-hover:text-primary transition-colors duration-300 leading-tight">
                    {project.name}
                  </h3>
                  <p className="font-body text-sm sm:text-base text-textSecondary mb-4 sm:mb-6 whitespace-pre-line leading-relaxed">
                    {project.description}
                  </p>
                </div>
                
                <div className="mt-auto">
                  <div className="border-t border-primary/20 pt-3 sm:pt-4">
                    <p className="font-body text-xs sm:text-sm text-textSecondary mb-2">Tech Stack:</p>
                    <p className="font-mono text-primary font-semibold text-xs sm:text-sm leading-relaxed">
                      {project.techStack}
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="h-1 bg-primary-gradient transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
            </div>
          ))}
        </div>

        {/* Call to Action Section - Mobile Optimized */}
        <div className="mt-12 sm:mt-14 md:mt-16 text-center">
          <div className="bg-backgroundDark p-6 sm:p-8 rounded-lg border border-primary/20">
            <h3 className="font-heading text-xl sm:text-2xl font-bold text-textPrimary mb-3 sm:mb-4">
              View Additional Work
            </h3>
            <p className="font-body text-textSecondary text-base sm:text-lg mb-4 sm:mb-6 leading-relaxed">
              More repositories, experiments, and implementation details are available on my GitHub profile.
            </p>
            <a 
              href="https://github.com/TheAryan04" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center bg-primary-gradient text-backgroundDark font-semibold px-4 sm:px-6 py-3 rounded-lg hover:opacity-90 transition-all duration-300 font-body text-sm sm:text-base"
            >
              View GitHub Profile
              <svg className="ml-2 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Projects
